/**
 * Created by elad on 15 נובמבר 2016.
 */
import VueRouter from "vue-router";
import middleware from "src/middleware";
import LoginView from "./views/auth/LoginView";
import Dashboard from "./layout/Dashboard";
import WelcomeView from "./views/WelcomeView";
import UsersView from "./views/users/UsersView";
import UserProfile from "./views/users/UserProfile";
import ProjectsView from "./views/projects/ProjectsView";
import ProjectForm from "./views/projects/ProjectForm";
import Project from "./views/projects/Project";
import PlanForm from "./views/plans/PlanForm";
import PlansView from "./views/plans/PlansView.vue";
import RegisterView from "./views/auth/RegisterView";
import ThankYouPage from "./views/plans/ThankYouPage";
import PaymentWaitingPage from "./views/plans/PaymentWaitingPage";
import LoginAdminPage from "./views/dashboard/LoginAdminView";
import CouponsView from "./views/coupons/CouponsView";
import LoadingView from "./views/LoadingView";
import Testing from "./views/auth/Testing";
import PassportsView from "./views/passport/PassportsView";
import SamlTestForm from "./views/passport/SamlTestForm";
import PassportLogin from "./views/auth/PassportLogin";
import PassportRegister from "@/views/auth/PassportRegister";
import Authorize from "./views/auth/Authorize";
import ForgotPassword from "@/views/auth/ForgotPassword";
import ResetPassword from "@/views/auth/ResetPassword";
import ErrorPage from "./views/errors/ErrorPage";
import PaymentErrorPage from "./views/plans/PaymentErrorPage";
import PurchaseHistory from "./views/purchases/PurchaseHistory";
import ProjectSubscriptions from "./views/projects/ProjectSubscriptions";
import ProjectMultiEdit from "./views/projects/ProjectMultiEdit.vue";
import store from "./store";
import IdentityView from "./views/auth/IdentityView";
import SelectMosad from "./views/auth/SelectMosad";
import MosadNotFoundMessage from "./views/auth/MosadNotFoundMessage";

const routes = [
  {
    path: "/",
    component: LoadingView,
    name: "loading-page"
  },
  {
    path: "/welcome",
    component: WelcomeView,
    name: "welcome-page"
  },
  {
    path: "/signin",
    component: LoginView,
    name: "login-page",
    props: true,
    meta: { guest: "main-dashboard" }
  },
  {
    path: "/identity",
    component: IdentityView,
    name: "identity-page",
    props: true,
    meta: { RequireAuth: { loginPage: "loading-page" } }
  },
  {
    name: "oauth-page",
    path: "/oauth/authorize",
    component: Authorize,
    props: true
  },
  {
    path: "/login",
    component: PassportLogin,
    name: "passport-login-page",
    props: true,
    meta: { guest: "main-dashboard" }
  },
  {
    name: "mosad-not-found",
    path: "/mosad-not-found",
    component: MosadNotFoundMessage
  },
  {
    path: "/admin/signin",
    component: LoginAdminPage,
    name: "admin-login-page",
    props: { admin: true },
    meta: { guest: "main-dashboard" }
  },
  {
    path: "/signup",
    component: RegisterView,
    name: "register-page",
    meta: { guest: "main-dashboard" },
    props: true,
  },
  {
    path: "/register",
    component: PassportRegister,
    name: "passport-register-page",
    meta: { guest: "main-dashboard" },
    props: true,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    name: "forgot-password-page",
    meta: { guest: "main-dashboard" },
    props: true
  },
  {
    path: "/reset-password/:token",
    component: ResetPassword,
    name: "reset-password-page",
    meta: { guest: "main-dashboard" },
    props: true
  },
  {
    path: "/plans",
    component: PlansView,
    name: "plans-view",
    meta: { RequireAuth: { loginPage: "loading-page" } }
  },
  {
    path: "/payments/thankYouPage",
    component: ThankYouPage,
    name: "thank-you-page",
    meta: { RequireAuth: { loginPage: "register-page" } }
  },
  {
    path: "/payments/waitingPage",
    component: PaymentWaitingPage,
    name: "payment-waiting-page",
    meta: { RequireAuth: { loginPage: "register-page" } }
  },
  {
    path: "/payments/errorPage",
    component: PaymentErrorPage,
    name: "payment-error-page",
    props: true,
  },
  {
    path: "/testing",
    component: Testing,
    name: "testing"
  },
  {
    path: "/saml-test",
    component: SamlTestForm,
    name: "saml-test-form"
  },
  {
    path: "/error/page",
    component: ErrorPage,
    name: "error-page"
  },
  {
    path: "*",
    component: ErrorPage,
    props: { statusCode: 404 }
  },
  {
    name: "user-profile-force",
    path: "/password/expired",
    component: UserProfile,
    meta: { RequireAuth: { loginPage: "register-page" } },
    props: { force: true }
  },
  {
    name: "select-mosad",
    path: "/select-mosad",
    component: SelectMosad,
    meta: { RequireAuth: { loginPage: "identity-page" } }
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { RequireAuth: { loginPage: "login-page" } },
    children: [
      {
        name: "main-dashboard",
        path: "",
        redirect: (to, a, b) => {
          if (store.getters.isAdmin) {
            return { name: "projects-view" };
          } else {
            return { name: "purchase-history" };
          }
        }
      },
      {
        name: "users-view",
        path: "users",
        component: UsersView,
        meta: { role: 0 }
      },
      {
        name: "projects-view",
        path: "projects",
        component: ProjectsView,
        meta: { role: 0 }
      },
      {
        name: "coupons-view",
        path: "coupons",
        component: CouponsView,
        meta: { role: 0 }
      },
      {
        name: "project-multi-edit",
        path: "project/:id/multi-edit",
        component: ProjectMultiEdit,
        meta: { role: 0 }
      },
      {
        name: "project-create",
        path: "project/create",
        component: ProjectForm,
        meta: { role: 0 }
      },
      {
        name: "project-edit",
        path: "project/:id/edit",
        component: ProjectForm,
        meta: { role: 0 }
      },
      {
        name: "project-view",
        path: "project/:id",
        props: true,
        component: Project,
        meta: { role: 0 }
      },
      {
        name: "project-subscriptions",
        path: "project/:id/subscriptions",
        props: true,
        component: ProjectSubscriptions
      },
      {
        name: "plan-create",
        path: "plan/create/:projectId",
        component: PlanForm,
        meta: { role: 0 }
      },
      {
        name: "plan-edit",
        path: "plan/edit/:planId",
        component: PlanForm,
        meta: { role: 0 }
      },
      {
        name: "passports-view",
        path: "passport",
        component: PassportsView,
        meta: { role: 0 }
      },
      {
        name: "purchase-history",
        path: "purchase",
        component: PurchaseHistory
      },
      {
        name: "user-profile",
        path: "profile",
        component: UserProfile
      }
    ]
  }
];

const router = new VueRouter({
  history: false,
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  middleware.check(to, from, next);
});

export default router;
